import React from "react";
import PropTypes from "prop-types";
//Material imports
import FormControlLabel from "@mui/material/FormControlLabel";
import MUICheckbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const useStyles = makeStyles(theme => ({
  checkBoxLabel: {
    paddingRight: 16
  },
  disabledLabel: {
    color: theme.palette.action.disabled
  }
}));
const Checkbox = ({
  t,
  label,
  value,
  checked,
  onChange,
  name,
  id,
  checkboxLabelRoot,
  disabled,
  capitalize,
  style
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(FormControlLabel, {
    classes: {
      root: checkboxLabelRoot,
      label: classes.checkBoxLabel
    },
    control: /*#__PURE__*/React.createElement(MUICheckbox, {
      id: id ? id : `${label}CheckBox`,
      value: value ? value : label,
      checked: checked,
      onChange: event => onChange(name, event.target.value, !checked),
      disabled: disabled,
      style: style
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      color: "textPrimary",
      style: {
        textTransform: capitalize ? "capitalize" : "unset",
        paddingRight: 16
      },
      className: `${disabled ? classes.disabledLabel : ""}`
    }, t(label))
  });
};
export default withi18n(Checkbox);
Checkbox.propTypes = {
  t: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  id: PropTypes.string,
  checkboxLabelRoot: PropTypes.string,
  disabled: PropTypes.bool,
  capitalize: PropTypes.bool,
  style: PropTypes.object
};
Checkbox.defaultProps = {
  checkboxLabelRoot: "",
  disabled: false,
  capitalize: true
};